export default "__VITE_ASSET__Ca8nVS7O__"